import { status } from "./constants";
import _ from "lodash";

export const isEnabled = (giftcard: any = {}): boolean => {
    const cardStatus = _.get(giftcard, "status");
    return cardStatus === true || cardStatus === status.ENABLED;
};
